export enum AuthActionTypes {
  'FETCH_GENERATE_TOKEN' = 'FETCH_GENERATE_TOKEN',
  'SET_USER_VERIFICATION' = 'SET_USER_VERIFICATION',
  'GET_USER_INFO' = 'GET_USER_INFO',
  'SET_FIRST_LOGIN' = 'SET_FIRST_LOGIN'
}
